export default __webpack_public_path__ + "static/task_schedule.3d2927209f0389045e8f304bb2aad20a.png";